import { theme } from "@local-logic/core/ui";
import { motion } from "framer-motion";
import { styled } from "styled-components";

export const Cluster = styled(motion.div)<{ diameter: number }>`
  border-radius: 50%;
  background: linear-gradient(
    to top,
    ${theme["--ll-color-primary-variant1"]},
    ${theme["--ll-color-primary"]}
  );
  color: ${theme["--ll-color-on-primary"]};
  height: ${({ diameter }) => diameter}px;
  width: ${({ diameter }) => diameter}px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;
  font-family: ${theme["--ll-font-family"]};
  font-size: ${({ diameter }) => diameter / 2.5}px;
  border: 2px solid #fff;
  box-shadow: ${theme["--ll-shadow-small"]};
  cursor: default;
`;

export const ClusterList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const ClusterListItem = styled.li`
  font-family: ${theme["--ll-font-family"]};
  padding: ${theme["--ll-spacing-x-small"]};
  background-color: ${theme["--ll-color-background"]};
  border-radius: ${theme["--ll-border-radius-small"]};
  border: 1px solid ${theme["--ll-color-border"]};
  cursor: default;

  &:not(:last-child) {
    margin-bottom: ${theme["--ll-spacing-xx-small"]};
  }

  &:hover {
    background-color: ${theme["--ll-color-surface"]};
  }
`;
